import { motion, useScroll } from "framer-motion";

export const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  return (
    <motion.div
      className="fixed top-0 left-0 right-0 h-[3px] origin-left z-[60]"
      style={{ scaleX: scrollYProgress, background: "linear-gradient(90deg, var(--tp), var(--tp-l), var(--ta))" }}
      data-testid="scroll-progress"
    />
  );
};
